import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Form, Offcanvas } from "react-bootstrap";
import '../../assets/css/Leads.css'
import { Link } from "react-router-dom";
import AddDeliveryBoy from "./Addworkshopmst";
import { toast, ToastContainer } from "react-toastify";
import { Tooltip } from "react-tooltip";
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import * as XLSX from 'xlsx';
import img from '../../assets/img/excel.png';


const Workshoplist = () => {
    const [leads, setLeads] = useState([]);
    const [search, setSearch] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(50); const [page, setPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModal1, setShowModal1] = useState(false);
    const [latitude, setlatitude] = useState(null);
    const [longitude, setlongitude] = useState(null);
    const [did, setdid] = useState(null);

    const center = useMemo(() => {
        return {
            lat: parseFloat(latitude),
            lng: parseFloat(longitude),
        };
    }, [latitude, longitude]);

    const [showForm, setShowForm] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [selectedBoy, setSelectedBoy] = useState(null);

    const mapContainerStyle = { width: '100%', height: '350px' };

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyCxtuQLTtr6G4ai6Tz-DiwB-rPKho3iHSs"
    });


    useEffect(() => {
        getLeadsData();
    }, []);

    const get_usersxlsx = async (id) => {

        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;

        const payload = { workshop_id: id }

        try {
            const response = await axios.post(
                `https://devapi.bykit.in/api/admin/get_biketransfer?export=csv&?type=live`, payload,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${token}`,
                    }
                }
            );

             console.log("Unexpected data format:", response.data.data);

            const dataArray =  response.data.data;

            if (!Array.isArray(dataArray)) {
                alert("Invalid response data format.");
                console.error("Unexpected data format:", response.data);
                return;
            }

            // Transform data for Excel
            const transformedData = dataArray.map((item, index) => {
                const pickupPrice = parseFloat(item.pickup_price || 0);
                const appServicePrice = parseFloat(item.service_price || 0);
                const workshopServicePrice = parseFloat(item.workshop_service_price || 0); // fallback to 0 if not present

                const totalCharges = pickupPrice + appServicePrice;
                //const bykitProfit = appServicePrice - workshopServicePrice;
                const pincode = item.address?.split(',').pop().trim();

                return {
                    "DATE": item.date,
                    "NAME OF DELIVERY BOY": item.deliveryboy_name,
                    "PICK UP LOCATION": item.to_workshop_name || "",
                    "DELIVERY LOCATION": item.from_workshop_name || "",
                    "MODEL": item.bike_details || "",
                    "CHASSIS NO": item.bike_details || "",
                    "TOTAL RECEIVED": item.amount || ""
                };
            });

            // Create Excel Sheet
            const worksheet = XLSX.utils.json_to_sheet(transformedData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "AllBookings");

            // Export file
            XLSX.writeFile(workbook, "workshopreport.xlsx");

        } catch (error) {
            console.error("Request failed:", error);
            alert("Something went wrong while exporting the file.");
        }
    };


    // Function to get rider location
    const get_rider_location = async (id) => {
        setdid(id);
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;

        try {
            const response = await axios.get(
                `https://devapi.bykit.in/api/users/get_rider_location/` + id + `??type=live`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data && response.data.data) {
                setlatitude(response.data.data.latitude);
                setlongitude(response.data.data.longitude);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {

        let interval;

        if (showModal1) {
            // Start the interval to call the API every 30 seconds
            interval = setInterval(() => {
                get_rider_location(did); // Fetch the rider location every 30 seconds
            }, 10000); // 30 seconds interval
        } else {
            // Clear the interval if showModal1 is false
            clearInterval(interval);
        }

        // Cleanup interval when the component unmounts or showModal1 changes
        return () => {
            clearInterval(interval);
        };
    }, [showModal1]); // Effect runs when showModal1 changes


    const getLeadsData = async () => {
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;


        const url = "https://devapi.bykit.in/api/admin/get_workshopaddress??type=live"
        const payload = {
            user_id: 1
        }
        try {
            const response = await axios.post(url, payload, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            console.log("All Bookings:", response.data);

            if (response.data?.data) {
                setLeads(response.data.data);
                setTotalRows(response.data.recordsTotal || 0);
            }
        } catch (error) {
            console.error("Error fetching data:", error.response?.data || error.message);
        }
    };

    const handlePageChange = (newPage) => setPage(newPage);
    const handleRowsPerPageChange = (newRows) => {
        setRowsPerPage(newRows);
        setPage(1);
    };

    const handleToggleStatus = async () => {
        if (!selectedBoy) return;
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;
        try {
            const response = await axios.get(
                `https://devapi.bykit.in/api/admin/delete_workshopaddress/${selectedBoy.id}??type=live`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log('manager account ', response)

            if (response.data?.status) {
                const message = "Workshop Successfully deleted";
                toast.success(message);
                getLeadsData();

                setShowModal(false);
            }
        } catch (error) {
            console.error("Error updating status:", error.response?.data || error.message);
        }
    };
    const columns = [
        {
            name: "Godown Name",
            cell: (row) => (
                <div className="">
                    <p>{row.name || "N/A"}</p>
                </div>
            ),
            sortable: true,
        },
        {
            name: "Address",
            cell: (row) => (
                <div className="">
                    <p>{row.address || "N/A"}</p>
                </div>
            ),
            sortable: false,
        },

        {
            name: "Pincode",
            cell: (row) => (
                <div className="">
                    <p>{(row.address ? row.address.split(' ').pop().trim() : "N/A")}</p>
                </div>
            ),
            sortable: false,
        },

        {
            name: "Action",
            cell: (row, index) => (
                <div className="d-flex justify-content-end">
                    <div>
                        <Tooltip id={`view-tooltip-${row.id}`} place="top" className="tooltip_bg" />
                        <button className="edit_btn me-2"
                            data-tooltip-id={`edit-tooltip-${row.id}`}
                            data-tooltip-content="Edit"
                            onClick={() => {
                                setSelectedBoy(row);
                                setShowForm(true);
                            }}>
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--heroicons" width="1em" height="1em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m16.862 4.487l1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"></path></svg>
                        </button>

                        <button className="edit_btn me-2"
                            data-tooltip-id={`edit-tooltip-${row.id}`}
                            data-tooltip-content="Delete"
                            onClick={() => {
                                setSelectedBoy(row);
                                setShowModal(true);

                            }}>
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--heroicons me-1 ri-close-fill" width="0.8em" height="0.8em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21q.512.078 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48 48 0 0 0-3.478-.397m-12 .562q.51-.088 1.022-.165m0 0a48 48 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a52 52 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a49 49 0 0 0-7.5 0"></path></svg>
                        </button>


                        <Tooltip id={`edit-tooltip-${row.id}`} place="top" className="tooltip_bg" />
                        {/* <button
                            className="workshop_btn"
                            data-tooltip-id={`status-tooltip-${row.id}`}
                            data-tooltip-content={row.status === 1 ? "Deactivate" : "Activate"}
                            onClick={() => {
                                setSelectedIndex(index);
                                setSelectedLead(row); // Store the clicked row
                                setShowModal(true);
                            }}
                        >
                            {row.status === 1 ? (
                                <i className="ri-close-fill" style={{ color: "#475569" }}></i>
                            ) : (
                                <i className="ri-check-fill" style={{ color: "#475569" }}></i>
                            )}
                        </button> */}

                        <Tooltip
                            id={`status-tooltip-${row.id}`}
                            place="top"
                            className={row.status === 1 ? "tooltip-activate" : "tooltip-deactivate"}
                        />
                    </div>




                </div>
            ),
        },
        {
            name: "Export",
            cell: (row) => (<button
                className="add_model_btn me-3"
                onClick={() => get_usersxlsx(row.id)}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.5em',
                }}
            >
                Export to Excel
                <img
                    src={img}
                    alt=""
                    className="pick_photo"
                    style={{ height: 22, width: 22 }}
                />
            </button>

            ),
            sortable: false,
        },
    ];

    return (
        <div className="container data-table-container p-2">
            <ToastContainer></ToastContainer>
            {!showForm && (
                <div>
                    <div className="d-flex align-items-center gap-3">
                        <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
                            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
                        </svg>

                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
                            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
                        </svg>

                        <p className="m-0">Godown</p>
                    </div>
                    <div className='managebrand_box mt-3 mb-2 pt-4 pb-1'>
                        <div>
                            <h4 className='dashboard_head ps-3 pb-4'>Godown</h4>
                        </div>
                        <hr></hr>
      


                        <div className="container-fluid mt-3 px-3">
                            <div className="row align-items-center gy-2">

                                {/* Search Input */}
                                <div className="col-12 col-md-7 d-flex flex-column flex-md-row align-items-start">
                                    <input
                                        type="text"
                                        placeholder="Search by keyword"
                                        className="search-input1 me-md-2 mb-2 mb-md-0 w-100"
                                        style={{ padding: '8px',maxWidth: '280px' }}
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>

                                {/* Add Button */}
                                <div className="col-12 col-md-5 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-md-end">
                                    <button
                                        className="add_workshop_btn w-100 w-md-auto"
                                        onClick={() => setShowForm(!showForm)}
                                         style={{ padding: '8px', maxWidth: '280px' }}
                                    >
                                        +Add Godown
                                    </button>
                                </div>

                            </div>
                        </div><br/>






                        {/* <div className="d-flex justify-content-between mt-3 px-3">
                            <div>
                                
                                
                            </div>
                        </div> */}



                        <DataTable
                            columns={columns}
                            data={
                                leads.filter((item) =>
                                    (item.address && item.address.toLowerCase().includes(search.toLowerCase())) ||
                                    (item.pincode && item.pincode.toLowerCase().includes(search.toLowerCase())) ||
                                    (item.name && item.name.toLowerCase().includes(search.toLowerCase())) ||
                                    (item.area && item.area.toLowerCase().includes(search.toLowerCase()))
                                )
                            } pagination
                            responsive
                            // paginationServer
                            //paginationTotalRows={totalRows}
                            paginationPerPage={rowsPerPage}
                            paginationRowsPerPageOptions={[50, 100, 200, 300, 400]}
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handleRowsPerPageChange}
                            customStyles={{
                                headRow: { style: { backgroundColor: "#E2E8F0", color: "#475569", fontWeight: "bold" } },
                                pagination: { style: { borderTop: "1px solid #ddd", padding: "10px", backgroundColor: "#f8f9fa" } },
                                cells: {
                                    style: {
                                        padding: "5px", // Reduces space between columns
                                        margin: "0",
                                    },
                                },
                                headCells: {
                                    style: {
                                        padding: "10px", // Reduces space in header cells
                                        margin: "0",
                                    },
                                },
                            }}
                        />
                    </div>

                </div>
            )}
            {/* Modal */}
            {showModal && (
                <div className="modal-overlay delete-overlay">
                    <div className="modal-content delete-content">
                        <div className="modal-header bg-dark text-white mt-0">
                            <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
                        </div>
                        <div className='p-3'>
                            <p className="delete_text">
                                Are you sure you want to delete this Godown?
                            </p>
                        </div>
                        <hr className='p-0 m-0'></hr>
                        <div className="modal-buttons text-end p-3">
                            <button onClick={() => setShowModal(false)} className='model_dlt_btn me-3'>No</button>
                            <button onClick={handleToggleStatus} className='model_dlt_btn'>Yes</button>
                        </div>
                    </div>
                </div>
            )}



            {showForm && <AddDeliveryBoy setShowForm={setShowForm} refreshManagers={getLeadsData} selectedBoy={selectedBoy} />}
        </div>
    );
};
export default Workshoplist;